import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

export const ImportantSafetyInfo = styled.div`
  margin-top: ${SPACER.medium};
`;

export const ImportantSafetyInfoLinkTag = styled.a`
  text-decoration: underline;
`;
